// images
import mtorQuality from "../../../assets/images/mtorQuality.png";
import mtorPrice from "../../../assets/images/mtorPrice.png";
import mtorCommitment from "../../../assets/images/mtorCommitment.png";
import whyMtorVector from "../../../assets/images/whyMtorVector.png";

// css
import classes from "./WhyMtor.module.css";

const WhyMtor = () => (
  <section className="mt-32 flex flex-col" id="whyMtor">
    <img src={whyMtorVector} alt="why mtor vector" className="w-24 h-12" />
    <h2 className="mt-5 mr-14 text-4xl">ليه موتور؟</h2>
    <div className="mx-4 md:mx-16 mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-6 md:gap-y-6 md:gap-x-6">
      {/* Mtor Commitment */}
      <div
        className={[
          classes.MtorCommitmentWrapper,
          "col-span-1 md:col-span-2 lg:col-span-1",
        ].join(" ")}
      >
        <article className="p-5 ah-full rounded-2xl bg-light-green flex flex-col items-center">
          <img src={mtorCommitment} alt="mtor quality" className="w-32 h-32 " />
          <div className="mt-4 mb-20 text-center">
            <h3 className="text-4xl">أسرع</h3>
            <p className="mt-6 text-2xl font-normal" dir="rtl" lang="ar">
              وفر على نفسك المشاوير .. هنوصلك القطعة لحد باب المركز
            </p>
          </div>
        </article>
      </div>

      {/* Mtor Price */}
      <div className={[classes.MtorPriceWrapper].join(" ")}>
        <article className="p-5 h-full rounded-3xl bg-light-blue flex flex-col items-center">
          <img src={mtorPrice} alt="mtor quality" className="w-32 h-32" />
          <div className="mt-4 mb-20 text-center">
            <h3 className="text-4xl">أوفر</h3>
            <p className="mt-6 text-2xl font-normal" dir="rtl" lang="ar">
              علشان نوفر عليك بنضمنلك ارخص سعر و أحسن جودة
            </p>
          </div>
        </article>
      </div>

      {/* Mtor Quality */}
      <div className={[classes.MtorQualityWrapper].join(" ")}>
        <article className="p-5 h-full rounded-3xl bg-light-orange flex flex-col items-center">
          <img src={mtorQuality} alt="mtor quality" className="w-32 h-32" />
          <div className="mt-4 mb-20 text-center">
            <h3 className="text-4xl">أضمن</h3>
            <p className="mt-6 text-2xl font-normal" dir="rtl" lang="ar">
              أطلب من موتور و احنا هنضملنك جودة القطعة
            </p>
          </div>
        </article>
      </div>
    </div>
  </section>
);

export default WhyMtor;
